import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import SearchBar from "../components/SearchBar";

function Home() {
  const navigate = useNavigate();
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    document.title = "KAR – Kelowna Auto Rentals | Premium Car Rentals in Kelowna & Vancouver";
    document.querySelector('meta[name="description"]')?.setAttribute("content",
      "KAR (Kelowna Auto Rentals) offers contactless luxury car rentals in Kelowna (YLW) and Vancouver (YVR). Book online — Corvette, Tesla, Ford Raptor, Bronco & more. No hidden fees."
    );
  }, []);

  const faqs = [
    { question: "What documents do I need to rent a car?", answer: "A valid driver’s license and a credit card are required." },
    { question: "Can drivers under 25 rent a car?", answer: "We accept drivers 25 and older. For special inquiries, please contact KAR customer service." },
    { question: "How does contactless pickup work?", answer: "The vehicle is remotely unlocked via KAR customer service, allowing you to access it without any in-person interaction." },
    { question: "Is insurance included?", answer: "Yes, insurance is included in the rental rates, which may vary depending on your driving record or experience." },
    { question: "What if my plans change?", answer: "Bookings can be modified or canceled up to 24 hours before pickup. Late cancellations may incur fees." },
    { question: "How do I contact KAR for support?", answer: "Reach us at info@karrentals.ca or call (250) 575-6041." },
    {
      question: 'How does vehicle drop-off work in Kelowna?',
      answer: 'KAR offers free contactless drop-off at Kelowna International Airport (YLW) and Orchard Park Mall using our 2-step secure check-in process. Your vehicle will be ready for pickup at your chosen location, eliminating the need to meet anyone in person. Simply follow the provided check-in instructions, and you’ll be on the road in minutes.',
    },
  ];

  const reviews = [
    {
      name: "Dylan N.",
      date: "December 13, 2024",
      text: "Seamless process from start to finish, very responsive and accommodating. The car was flawless as well, very comfortable and efficient ride. I’ll be sure to reach out next time I am in town. Thanks again!",
   },
    {
      name: "Taylor Brody",
      date: "January 20, 2025",
      text: "We rented an amazing Raptor truck from Joey at Kelowna Auto Rentals. The truck was ready for us at the airport super clean and full of gas. Left it at the airport, super fast and easy. I can’t wait to rent the next time I’m in town. Best cars, great service.",
    },
    {
      name: "Cory Smith",
      date: "January 3, 2025",
      text: "I had the pleasure of renting a couple of vehicles from Joey And the company Kelowna auto rentals. Great personality very professional vehicles are always dropped off on time and are always clean and in excellent condition always full tank of gas, couldn’t ask for a better company to rent from!…would highly recommend to anybody That is looking to rent.",
    },
  ];

  const toggleFAQ = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const handleSearch = (location, startDateTime, endDateTime) => {
    navigate(`/results?location=${location}&start_date=${startDateTime}&end_date=${endDateTime}`);
  };

  return (
    <Layout>
      {/* Book a Ride Section */}
      <div id="bookaride" className="p-4 sm:px-6 lg:px-12">
        <SearchBar initialLocation="Kelowna" onSearch={handleSearch} />
      </div>

      {/* Why Choose Us Section */}
      <section className="text-center p-6 sm:px-8 lg:px-16">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">WHY CHOOSE US?</h2>
        <ul className="space-y-6 text-lg sm:text-xl lg:text-2xl">
          <li>
            <strong>Contactless Pickup:</strong> Fast, free, and hassle-free at YLW & YVR.
          </li>
          <li>
            <strong>Premium Fleet:</strong> Luxury and adventure-ready vehicles for every need.
          </li>
          <li>
            <strong>Well-Maintained Cars:</strong> Every vehicle undergoes a 12-step cleaning and inspection.
          </li>
          <li>
            <strong>Transparent Pricing:</strong> No hidden fees – <strong>ever</strong>.
          </li>
        </ul>
        <div className="mt-6">
          <button
            onClick={() => navigate('/fleet')}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg"
          >
            OUR FLEET
          </button>
        </div>
      </section>

      {/* Logos Section */}
      <div id="logos" className="bg-black py-6">
        <div className="container mx-auto items-center justify-items-center">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 items-center justify-items-center">
              <img src="/car_logos/fordraptorlogo.png" alt="Ford Raptor" className="h-16 sm:h-20 object-contain hover:scale-105 transition duration-300" />
              <img src="/car_logos/teslalogo.png" alt="Tesla" className="h-16 sm:h-20 object-contain hover:scale-105 transition duration-300" />
              <img src="/car_logos/mercedeslogo.png" alt="Mercedes" className="h-16 sm:h-20 object-contain hover:scale-105 transition duration-300" />
              <img src="/car_logos/corvettelogo.png" alt="Corvette" className="h-16 sm:h-20 object-contain hover:scale-105 transition duration-300" />
              <img src="/car_logos/broncologo.png" alt="Bronco" className="h-16 sm:h-20 hidden md:block object-contain hover:scale-105 transition duration-300" />
            </div>
            <img src="/car_logos/broncologo.png" alt="Bronco" className="h-16 sm:h-20 md:hidden sm:block object-contain hover:scale-105 transition duration-300" />
        </div>
      </div>

      {/* Reviews Section with Grid Layout */}
      <section className="p-6 sm:p-8 lg:p-16 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">What Our Customers Say</h2>
        <p className="text-lg sm:text-xl lg:text-2xl mb-4">
          Real experiences from real customers. See what makes us a top choice for car rentals!
        </p>
      </section>

      {/* Reviews Section with Grid Layout */}
      <section className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6 px-6 sm:px-8 lg:px-16 mb-6">
        {reviews.map((review, index) => (
          <div key={index} className="bg-white shadow-md rounded-2xl p-6">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-black text-xl font-semibold">{review.name}</h3>
              <p className="text-gray-500 text-sm">{review.date}</p>
            </div>
            <div className="flex items-center mb-4">
              <img src="/reviews/stars.png" alt="Stars" className="h-5 w-auto" />
            </div>
            <p className="text-gray-600">{review.text}</p>
          </div>
        ))}
      </section>

      {/* About Us Section */}
        <section id="aboutus" className="p-6 sm:p-8 lg:p-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 text-center">About Us</h2>

            {/* Large Screens Layout */}
            <div className="hidden lg:grid lg:grid-cols-2 gap-8 items-center">
                <div className="text-lg sm:text-xl lg:text-2xl leading-relaxed">
                    <p>KAR, an acronym for Kelowna Auto Rentals, was founded with a simple yet powerful vision: to redefine the car rental experience with a focus on quality, convenience, and customer satisfaction.</p>
                    <p className="mt-6">What began as a local service in Kelowna has grown into a trusted brand known for seamless, reliable rentals. Our mission is to make every journey effortless, offering a service that values your time and delivers unmatched reliability.</p>
                    <p className="mt-6">At KAR, we are driven by the belief that exceptional service transforms travel, and we’re committed to ensuring every customer enjoys an unparalleled rental experience.</p>
                </div>
                <img src="/tesla.png" alt="Our Tesla" className="rounded-2xl shadow-md" />
            </div>

            {/* Small Screens Layout */}
            <div className="lg:hidden relative">
                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-center rounded-2xl"
                    style={{
                        backgroundImage: `url('/primary.JPG')`, // Replace with your vertical Tesla image
                    }}
                ></div>

                {/* Black Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>

                {/* Text Content */}
                <div className="relative z-10 text-white p-6 sm:p-8">
                    <p className="text-lg sm:text-xl leading-relaxed">
                        KAR, an acronym for Kelowna Auto Rentals, was founded with a simple yet powerful vision: to redefine the car rental experience with a focus on quality, convenience, and customer satisfaction.
                    </p>
                    <p className="mt-6 text-lg sm:text-xl leading-relaxed">
                        What began as a local service in Kelowna has grown into a trusted brand known for seamless, reliable rentals. Our mission is to make every journey effortless, offering a service that values your time and delivers unmatched reliability.
                    </p>
                    <p className="mt-6 text-lg sm:text-xl leading-relaxed">
                        At KAR, we are driven by the belief that exceptional service transforms travel, and we’re committed to ensuring every customer enjoys an unparalleled rental experience.
                    </p>
                </div>
            </div>
        </section>


      {/* FAQs Section */}
        <section id="faqs" className="p-6 sm:p-8 lg:p-12">
            <div className="relative rounded-2xl overflow-hidden">
                {/* Background Images for Different Screen Sizes */}
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                        backgroundImage: `url('/ford.png')`,
                    }}
                ></div>
                <div
                    className="absolute inset-0 bg-cover bg-center sm:hidden"
                    style={{
                        backgroundImage: `url('/1.JPG')`,
                    }}
                ></div>

                {/* Black Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>

                {/* Content */}
                <div className="relative z-10 p-6 sm:p-8 lg:p-12">
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 text-center text-white">
                        Frequently Asked Questions
                    </h2>
                    <div className="bg-black bg-opacity-75 rounded-xl p-4 sm:p-6 lg:p-8">
                        {faqs.map((faq, index) => (
                            <div key={index} className="mb-4">
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggleFAQ(index)}
                                >
                                    <h3 className="text-lg sm:text-xl font-semibold text-white">{faq.question}</h3>
                                    <span className="text-white text-2xl">{expandedIndex === index ? "−" : "+"}</span>
                                </div>
                                {expandedIndex === index && (
                                    <p className="text-white mt-2 text-base sm:text-lg">{faq.answer}</p>
                                )}
                            </div>
                        ))}
                    </div>
                    {/* More FAQs Button */}
                    <div className="text-center mt-6">
                        <button
                            onClick={() => navigate('/faqs')}
                            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg"
                        >
                            More FAQs
                        </button>
                    </div>
                </div>
            </div>
        </section>


      {/* Contact Us Section */}
        <section id="contactus" className="p-6 sm:p-8 lg:p-16">
        {/* Large Screens Layout */}
        <div className="hidden lg:grid lg:grid-cols-2 gap-8">
            <div
            className="bg-cover bg-center rounded-2xl h-64 lg:h-auto"
            style={{ backgroundImage: 'url("/mercedes.png")' }}
            ></div>
            <div className="bg-black text-white p-6 sm:p-8 lg:p-12 rounded-2xl">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">Contact Us</h2>
            <p className="text-lg sm:text-xl mb-4">Email: info@karrentals.ca</p>
            <p className="text-lg sm:text-xl mb-4">Phone: +1 (250) 575-6041</p>
            <p className="text-lg sm:text-xl">Business Hours: 9:00 AM – 5:00 PM PST, 7 days a week</p>
            </div>
        </div>

        {/* Small Screens Layout */}
        <div className="lg:hidden relative bg-cover bg-center rounded-2xl" style={{ backgroundImage: 'url("/mercedes.png")' }}>
            {/* Black Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-50 rounded-2xl"></div>

            {/* Text Content */}
            <div className="relative z-10 text-white p-6 sm:p-8">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6">Contact Us</h2>
            <p className="text-lg sm:text-xl mb-4">Email: info@karrentals.ca</p>
            <p className="text-lg sm:text-xl mb-4">Phone: +1 (250) 575-6041</p>
            <p className="text-lg sm:text-xl">Business Hours: 9:00 AM – 5:00 PM PST, 7 days a week</p>
            </div>
        </div>
        </section>
    </Layout>
  );
}

export default Home;
